<div
	ucImpression
	(onImpression)="onCourseImpression($event)"
	class="items-center justify-between py-4 border-gray-200 sm:flex"
	[ngClass]="{ 'border-t': !isFirst(), 'pb-0': isLast() }"
>
	<!-- course title -->
	<div class="block w-full">
		<div class="flex items-center justify-between">
			<h3>
				<a
					(click)="onCourseProfileClick()"
					[routerLink]="['/universities', uniSlug(), product(), course().slug]"
					class="block text-base font-semibold text-gray-900 sm:text-lg"
				>
					{{ course().name }}
				</a>
			</h3>

			<uc-bookmark
				class="sm:hidden"
				[saved]="course().saved"
				[id]="course().id"
				[uniName]="uniName()"
				[courseSlug]="course().slug"
				[delta]="2"
				[showDesktopOnMobile]="true"
				componentName="Course Listing"
				[product]="product()"
				[bookmarkHeartIcon]="true"
				[ugSearchOrderPosition]="ugSearchOrderPosition()"
				[cleSearchOrderPosition]="null"
				[academicYear]="course().year"
			/>
		</div>

		<div class="mt-1 text-sm text-gray-500 sm:flex sm:flex-wrap">
			<!-- location -->
			@if (course().location) {
				{{ course().location }}
			}

			<!-- options -->
			@if (course().study_mode) {
				@if (course().location) {
					&middot;
				}
				{{ course().study_mode }}
			}

			<!-- points -->
			@if (course().min_ucas_tariff !== 0 || course().max_ucas_tariff !== 0) {
				@if (course().study_mode) {
					&middot;
				}
				@if (course().min_ucas_tariff) {
					{{ course().min_ucas_tariff }}
				}
				@if (
					course().min_ucas_tariff !== course().max_ucas_tariff &&
					course().max_ucas_tariff !== 0
				) {
					- {{ course().max_ucas_tariff }}
				}
				Points
			}
		</div>
	</div>

	<!-- (empty) cta buttons -->
	<ng-content select="[ctaButtons]"></ng-content>
</div>
